import styled, { css } from 'styled-components';
var PARAGRAPH_STYLE = css(["font-weight:", ";font-size:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.font.weight.normal;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.font.size.base;
});
export var H1 = styled.h1.withConfig({
  displayName: "Typography__H1",
  componentId: "sc-1o6hsoi-0"
})(["font-weight:", ";font-size:", ";line-height:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.font.weight.medium;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.font.size.xxlarge;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.font.lineHeights.lineHeight;
});
export var H2 = styled.h2.withConfig({
  displayName: "Typography__H2",
  componentId: "sc-1o6hsoi-1"
})(["font-weight:", ";font-size:", ";line-height:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.font.weight.medium;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.font.size.large;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.font.lineHeights.lineHeight;
});
export var H3 = styled.h3.withConfig({
  displayName: "Typography__H3",
  componentId: "sc-1o6hsoi-2"
})(["font-weight:", ";font-size:", ";line-height:", ";"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.font.weight.medium;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.font.size.medium;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.font.lineHeights.lineHeight;
});
export var H4 = styled.h4.withConfig({
  displayName: "Typography__H4",
  componentId: "sc-1o6hsoi-3"
})(["font-weight:", ";font-size:", ";line-height:", ";"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.font.weight.medium;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.font.size.base;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.font.lineHeights.lineHeight;
});
export var H5 = styled.h5.withConfig({
  displayName: "Typography__H5",
  componentId: "sc-1o6hsoi-4"
})(["font-weight:", ";font-size:", ";line-height:", ";letter-spacing:1px;text-transform:uppercase;"], function (_ref15) {
  var theme = _ref15.theme;
  return theme.font.weight.demi;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.font.size.small;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.font.lineHeights.lineHeight;
});
export var Label1 = styled.label.withConfig({
  displayName: "Typography__Label1",
  componentId: "sc-1o6hsoi-5"
})(["font-weight:", ";font-size:", ";"], function (_ref18) {
  var theme = _ref18.theme;
  return theme.font.weight.medium;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.font.size.base;
});
export var Label2 = styled.label.withConfig({
  displayName: "Typography__Label2",
  componentId: "sc-1o6hsoi-6"
})(["font-weight:", ";font-size:", ";line-height:", ";text-transform:uppercase;letter-spacing:0.3px;"], function (_ref20) {
  var theme = _ref20.theme;
  return theme.font.weight.medium;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.font.size.small;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.font.lineHeights.lineHeight;
});
export var Label3 = styled.label.withConfig({
  displayName: "Typography__Label3",
  componentId: "sc-1o6hsoi-7"
})(["font-weight:", ";font-size:", ";line-height:", ";"], function (_ref23) {
  var theme = _ref23.theme;
  return theme.font.weight.medium;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.font.size.medium;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.font.lineHeights.lineHeight;
});
export var Label4 = styled.label.withConfig({
  displayName: "Typography__Label4",
  componentId: "sc-1o6hsoi-8"
})(["font-weight:", ";font-size:11px;line-height:", ";text-transform:uppercase;"], function (_ref26) {
  var theme = _ref26.theme;
  return theme.font.weight.demi;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.font.lineHeights.lineHeight;
});
export var P = styled.p.withConfig({
  displayName: "Typography__P",
  componentId: "sc-1o6hsoi-9"
})(["", ""], PARAGRAPH_STYLE);
export var P1 = styled.label.withConfig({
  displayName: "Typography__P1",
  componentId: "sc-1o6hsoi-10"
})(["font-weight:", ";font-size:", ";line-height:", ";"], function (_ref28) {
  var theme = _ref28.theme;
  return theme.font.weight.normal;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.font.size.medium;
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.font.lineHeights.lineHeight;
});
export var P2 = styled.label.withConfig({
  displayName: "Typography__P2",
  componentId: "sc-1o6hsoi-11"
})(["font-weight:", ";font-size:", ";line-height:", ";"], function (_ref31) {
  var theme = _ref31.theme;
  return theme.font.weight.medium;
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.font.size.medium;
}, function (_ref33) {
  var theme = _ref33.theme;
  return theme.font.lineHeights.lineHeight;
});
export var Hint = styled.label.withConfig({
  displayName: "Typography__Hint",
  componentId: "sc-1o6hsoi-12"
})(["font-size:", ";line-height:", ";"], function (_ref34) {
  var theme = _ref34.theme;
  return theme.font.size.medium;
}, function (_ref35) {
  var theme = _ref35.theme;
  return theme.font.lineHeights.lineHeight;
});
export var Display = styled.label.withConfig({
  displayName: "Typography__Display",
  componentId: "sc-1o6hsoi-13"
})(["font-weight:", ";font-size:", ";line-height:", ";"], function (_ref36) {
  var theme = _ref36.theme;
  return theme.font.weight.medium;
}, function (_ref37) {
  var theme = _ref37.theme;
  return theme.font.size.xxxlarge;
}, function (_ref38) {
  var theme = _ref38.theme;
  return theme.font.lineHeights.lineHeight;
});